// api/authAPI.ts
import qs from "qs";
import apiClient from './apiClient';

const fetchSubscriptionAPI = async ({
	originalOrderId,
	email,
}: {
	originalOrderId?: string;
	email?: string;
}) => {
	const query = qs.stringify({ originalOrderId, email });

	const res = await apiClient.get(`/api/admin/business/subscription?${query}`);
	return res.data;
}

const subscriptionAPI = {
	fetchSubscriptionAPI,
}

export default subscriptionAPI;
